/*
 * Articoli del blog: piccole cure sul corpo scritto dall'editor.
 * Niente librerie. Se non parte, la pagina resta comunque leggibile:
 * i titoli, il testo e la card prodotto sono gia' nell'HTML.
 *
 * 1. toglie i paragrafi e i titoli vuoti lasciati dall'editor
 * 2. mette il capolettera sul primo paragrafo vero
 * 3. se il corpo non ha H2, gli H3 prendono l'aspetto degli H2
 * 4. con almeno 3 titoli costruisce l'indice "In questo articolo"
 *    (di lato su schermi larghi, dopo il primo paragrafo altrimenti)
 * 5. sposta la card "Scopri la candela" a meta' articolo
 * 6. barra di lettura in alto
 */
(function () {
  var corpo = document.querySelector('.article-template__content');
  if (!corpo) return;

  function vuoto(el) {
    return !el.textContent.replace(/ /g, ' ').trim() && !el.querySelector('img, iframe, video, svg');
  }

  // 1. pulizia
  Array.prototype.slice.call(corpo.querySelectorAll('p, h2, h3, h4')).forEach(function (el) {
    if (vuoto(el)) el.remove();
  });

  // 2. capolettera
  var paragrafi = Array.prototype.slice.call(corpo.children).filter(function (el) {
    return el.tagName === 'P' && !el.querySelector('img');
  });
  if (paragrafi.length && paragrafi[0].textContent.trim().length >= 60) {
    paragrafi[0].classList.add('art-capolettera');
  }
  corpo.classList.add('art-pronto');

  // 3. livello dei titoli
  var titoli = Array.prototype.slice.call(corpo.querySelectorAll('h2'));
  if (!titoli.length) corpo.classList.add('art-senza-h2');
  if (titoli.length < 3) {
    var h3 = Array.prototype.slice.call(corpo.querySelectorAll('h3'));
    if (h3.length >= 3) titoli = h3;
  }

  // ancore stabili sui titoli (servono all'indice e ai link condivisi)
  var usati = {};
  titoli.forEach(function (t, i) {
    if (t.id) {
      usati[t.id] = true;
      return;
    }
    var base = t.textContent
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'sezione';
    var id = base;
    var n = 2;
    while (usati[id] || document.getElementById(id)) id = base + '-' + n++;
    usati[id] = true;
    t.id = id;
  });

  // 4. indice
  if (titoli.length >= 3 && corpo.dataset.indice !== 'no' && !corpo.querySelector('.art-indice')) {
    var nav = document.createElement('nav');
    nav.className = 'art-indice art-indice--auto';
    nav.setAttribute('aria-label', corpo.dataset.indiceTitolo || 'In questo articolo');
    var etichetta = document.createElement('p');
    etichetta.className = 'art-indice__titolo';
    etichetta.textContent = corpo.dataset.indiceTitolo || 'In questo articolo';
    var ol = document.createElement('ol');
    titoli.forEach(function (t) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + t.id;
      a.textContent = t.textContent.trim().replace(/^\d+\s*[.)]\s*/, '');
      li.appendChild(a);
      ol.appendChild(li);
    });
    nav.appendChild(etichetta);
    nav.appendChild(ol);

    var lato = document.querySelector('.articolo__lato');
    if (lato && window.matchMedia('(min-width: 1200px)').matches) {
      lato.appendChild(nav);
      lato.closest('.articolo').classList.add('articolo--con-lato');
    } else if (paragrafi.length) {
      paragrafi[0].insertAdjacentElement('afterend', nav);
    } else {
      corpo.insertAdjacentElement('afterbegin', nav);
    }
  }

  // 5. card prodotto a meta' articolo
  var card = document.querySelector('.art-scopri[data-sposta]');
  if (card) {
    var dove = null;
    if (titoli.length >= 3) {
      dove = titoli[2]; // fine della seconda sezione
      dove.insertAdjacentElement('beforebegin', card);
    } else if (paragrafi.length >= 6) {
      dove = paragrafi[Math.floor(paragrafi.length / 2) - 1];
      dove.insertAdjacentElement('afterend', card);
    }
    // altrimenti resta dove l'ha messa il tema: subito sotto il corpo
  }

  // 6. barra di lettura
  var barra = document.querySelector('.art-barra');
  if (barra) {
    var attesa = false;
    var aggiorna = function () {
      var r = corpo.getBoundingClientRect();
      var corsa = r.height - window.innerHeight * 0.6;
      var v = corsa > 0 ? -r.top / corsa : 1;
      barra.style.transform = 'scaleX(' + Math.min(1, Math.max(0, v)) + ')';
      attesa = false;
    };
    window.addEventListener(
      'scroll',
      function () {
        if (!attesa) {
          attesa = true;
          window.requestAnimationFrame(aggiorna);
        }
      },
      { passive: true }
    );
    aggiorna();
  }
})();
